import React, { useState, useMemo, useEffect, useRef } from "react";
import { CapsuleTabs, Toast, Empty } from "antd-mobile";
import { getSearchResult } from "../../services/services";
import StandardCard from "../StandardCard";
import { FormattedMessage } from 'react-intl';
// ResultSearch 组件用于展示搜索结果
export default function ResultSearch({ searchArg, assignSearchArg }) {
  const { value, type, identify } = searchArg;
  const handler = useRef(null);
  const [data, setData] = useState([]);

  // 根据搜索类型确定搜索类别
  const category = useMemo(() => {
    switch (type) {
      case "firmware":
        return "firmware";
      case "documents":
        return "Specifications,Manuals,DeveloperDocumentation,StructuralDrawings,Flyers";
      case "DeveloperTools":
        return "DeveloperTools,apps,dockers";
      default:
        return undefined;
    }
  }, [type]);

  // 发起搜索请求
  useEffect(() => {
    async function httpSearch() {
      handler.current = Toast.show({
        icon: "loading",
        content: 'loading',
        duration: 0,
      });
      const res = await getSearchResult({
        name: value,
        category,
      });
      if (res.status === 200) {
        handler.current.close();
        setData(res.result);
      } else {
        Toast.show({
          content: res.error,
          duration: 3000,
        });
      }
    }
    httpSearch();
  }, [value, category, identify]);


  // 根据搜索结果展示数据
  const showData =
    data.length > 0 ? (
      data.map((item, index) => (
        <div
          key={index}
          style={{ marginBottom: 10 }}
        >
          <StandardCard
            data={item}
            category={category}
          />
        </div>
      ))
    ) : (
      <Empty
        style={{ padding: "64px 0" }}
        imageStyle={{ width: 128 }}
        description="no data"
      />
    );

  // 根据搜索类型展示搜索结果
  return (
    <>
      <CapsuleTabs
        defaultActiveKey="firmware"
        activeKey={type}
        onChange={key => assignSearchArg({ ...searchArg, type: key })}
      >
        {initType.map(item => (
          <CapsuleTabs.Tab
            title={item.name}
            key={item.id}
          >
            {showData}
          </CapsuleTabs.Tab>
        ))}
      </CapsuleTabs>
    </>
  );
}

// 初始搜索类型
const initType = [
  {
    id: "firmware",
    name: <FormattedMessage id='FileName' />,
  },
  {
    id: "documents",
    name: <FormattedMessage id='FileNDocumentame' />,
  },
  {
    id: "DeveloperTools",
    name: <FormattedMessage id='Tools' />,
  },
];
